import { render } from "./ProductQuantityDiscount.vue?vue&type=template&id=271cf3a2&scoped=true"
import script from "./ProductQuantityDiscount.vue?vue&type=script&lang=js"
export * from "./ProductQuantityDiscount.vue?vue&type=script&lang=js"

import "./ProductQuantityDiscount.vue?vue&type=style&index=0&id=271cf3a2&scoped=true&lang=css"

import exportComponent from "/home/forge/backoffice.callmewine.co.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-271cf3a2"]])

export default __exports__